import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Button, Group, Modal, Text } from "@mantine/core"
import type { IProps } from "./interfaces"

/**
 * "Stop recording?" confirmation — shared between the legacy panel and the
 * Lexicanon focus mode. Dumb: the smart wrapper owns `opened` state and the
 * actual finalize logic. The title does not change per product.
 */
export const FinishConfirmModal = ({ opened, onClose, onConfirm, loading = false }: IProps): React.JSX.Element => {
  const { i18n } = useLingui()

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={i18n._(msg`Stop recording?`)}
      centered
      closeOnClickOutside={!loading}
      closeOnEscape={!loading}
      withCloseButton={!loading}
    >
      <Text size="sm" c="dimmed" mb="md">
        <Trans>
          This will stop the recording, upload the final audio, and generate the definitive transcript and summary.
        </Trans>
      </Text>
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose} disabled={loading}>
          <Trans>Keep recording</Trans>
        </Button>
        <Button color="brand" onClick={onConfirm} loading={loading} data-testid="recording-finish-confirm">
          <Trans>Stop recording</Trans>
        </Button>
      </Group>
    </Modal>
  )
}
